<template>
  <v-container>
    <v-chip-group mandatory active-class="primary--text" v-model="tab">
      <v-chip key="active" active-class="primary"> Active</v-chip>
      <v-chip key="arcived" active-class="primary"> Archived</v-chip>
    </v-chip-group>
    <v-data-table
      :headers="headers"
      :items="selectedTrips"
      :items-per-page="15"
      class="elevation-1"
    ></v-data-table>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

export default {
  name: "CompanyTrips",
  props: ["companyId"],
  data() {
    return {
      tab: "active",
      headers: [
        {
          text: this.$t("common.name"),
          align: "left",
          value: "name",
        },
        {
          text: this.$t("common.created"),
          value: "created",
        },
        {
          text: this.$t("common.admins"),
          value: "adminsCount",
        },
        {
          text: this.$t("common.travelers"),
          value: "travelersCount",
        },
        {
          text: this.$t("common.removedUsers"),
          value: "removedUsersCount",
        },
        {
          text: this.$t("common.status"),
          value: "status",
        },
      ],
      trips: [],
    };
  },
  watch: {
    companyId(newVal) {
      this.trips = [];
      this.getCompanyTrips(newVal);
    },
  },
  methods: {
    getCompanyTrips(companyId) {
      const firestore = firebase.firestore();
      firestore
        .collection("groups")
        .where("company", "==", companyId)
        .get()
        .then((snaps) => {
          snaps.forEach((snap) => {
            const trip = snap.data();

            const allTravelers = Object.values(trip.user_ids);
            const travelersCount = allTravelers.filter((user) => user !== true).length;
            const adminsCount = allTravelers.length - travelersCount;
            const removedUsersCount = Object.keys(trip.removed_users ?? {}).length;

            const now = new Date().getTime();
            const startDate = trip.start_date.toDate().getTime();
            const endDate = trip.end_date.toDate().getTime();
            const created = trip.created ? trip.created.toDate().toLocaleDateString() : "";
            let status = "";
            if ((now >= startDate && now <= endDate) || startDate === 0 || endDate === 0) {
              status = this.$t("common.inProgress");
            } else if (startDate >= now) {
              status = this.$t("common.upcoming");
            } else {
              status = this.$t("common.finished");
            }
            this.trips.push({
              name: trip.name,
              created,
              travelersCount,
              adminsCount,
              removedUsersCount,
              status,
              archived: trip.archived || false,
            });
          });
        })
        .catch((e) => {
          console.log(e.message);
        });
      console.log(this.trips);
    },
  },
  computed: {
    selectedTrips() {
      return this.trips.filter((trip) => (this.tab === 1 ? trip.archived : !trip.archived));
    },
  },
  created() {
    console.log("CompanyTipsCreated");
    console.log(this.$props.companyId);
    this.getCompanyTrips(this.$props.companyId);
  },
};
</script>
